import { render, staticRenderFns } from "./ListadoFormulas.vue?vue&type=template&id=3740cd86&"
import script from "./ListadoFormulas.vue?vue&type=script&lang=js&"
export * from "./ListadoFormulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports